import React, { useState } from 'react';
import './TaskAssumptionModal.css';

function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function ClaimableRow({ task, onClaim, busy }) {
  return (
    <div className="tam-row">
      <div className="tam-row-main">
        <div className="tam-row-title">{task.nume}</div>
        <div className="tam-row-sub">Termen: {fmtDate(task.termen_limita)}</div>
      </div>
      <button type="button" className="btn btn-primary btn-sm" disabled={busy} onClick={() => onClaim(task.id)}>
        Asigneaza la mine
      </button>
    </div>
  );
}

function EscalatedRow({ task, staffUsers, onDecision, busy }) {
  const [reassigning, setReassigning] = useState(false);
  const [target, setTarget] = useState('');

  const handleCancel = () => {
    const motiv = window.prompt('Motivul anularii acestui task:') || '';
    onDecision(task.id, { action: 'cancel', motiv });
  };

  const handleConfirmReassign = () => {
    if (!target) return;
    onDecision(task.id, { action: 'reassign', assignee_id: Number(target) });
    setReassigning(false);
  };

  return (
    <div className="tam-row tam-row-escalated">
      <div className="tam-row-main">
        <div className="tam-row-title">{task.nume}</div>
        <div className="tam-row-sub">Termen: {fmtDate(task.termen_limita)} · neasumat de 5+ zile lucratoare</div>
      </div>
      {reassigning ? (
        <div className="tam-reassign">
          <select className="tam-reassign-select" value={target} onChange={e => setTarget(e.target.value)}>
            <option value="">— Alege utilizator —</option>
            {staffUsers.map(u => <option key={u.id} value={u.id}>{u.full_name}</option>)}
          </select>
          <button type="button" className="btn btn-primary btn-sm" disabled={!target || busy} onClick={handleConfirmReassign}>Confirma</button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => setReassigning(false)}>Renunta</button>
        </div>
      ) : (
        <div className="tam-actions">
          <button type="button" className="btn btn-secondary btn-sm" disabled={busy} onClick={() => onDecision(task.id, { action: 'keep' })}>Pastreaza</button>
          <button type="button" className="btn btn-secondary btn-sm" disabled={busy} onClick={() => setReassigning(true)}>Reatribuie</button>
          <button type="button" className="btn btn-danger btn-sm" disabled={busy} onClick={handleCancel}>Anuleaza</button>
        </div>
      )}
    </div>
  );
}

export default function TaskAssumptionModal({ claimable, escalated, staffUsers, onClose, onClaim, onCoordinatorDecision }) {
  const [busy, setBusy] = useState(false);

  const wrapClaim = async (id) => {
    setBusy(true);
    try { await onClaim(id); } finally { setBusy(false); }
  };

  const wrapDecision = async (id, payload) => {
    setBusy(true);
    try { await onCoordinatorDecision(id, payload); } finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box tam-modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-sticky-header">
          <div className="op-modal-head">
            <div className="op-modal-title">Task-uri neasignate</div>
            <button className="btn btn-ghost btn-sm" type="button" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-scroll-body">
          {claimable.length > 0 && (
            <div className="tam-section">
              <div className="tam-section-title">De asignat ({claimable.length})</div>
              {claimable.map(t => <ClaimableRow key={t.id} task={t} onClaim={wrapClaim} busy={busy} />)}
            </div>
          )}

          {escalated.length > 0 && (
            <div className="tam-section">
              <div className="tam-section-title">Neasignate — decizie coordonator ({escalated.length})</div>
              {escalated.map(t => (
                <EscalatedRow key={t.id} task={t} staffUsers={staffUsers} onDecision={wrapDecision} busy={busy} />
              ))}
            </div>
          )}

          {claimable.length === 0 && escalated.length === 0 && (
            <div className="tam-empty">Niciun task neasignat.</div>
          )}
        </div>
      </div>
    </div>
  );
}
